import { LeagueDiscountResp } from 'types/league/leagueDiscount'
import { LeagueTeamResp } from 'types/team/leagueTeam'
import { create } from 'zustand'

const manageTeamStoreStates = (set: any) => ({
  manageTeamModal: false,
  setManageTeamModal: (state: boolean) =>
    set(() => ({
      manageTeamModal: state,
    })),
  addTeamModal: false,
  setAddTeamModal: (state: boolean) =>
    set(() => ({
      addTeamModal: state,
    })),
  createLeagueTeamModal: false,
  setCreateLeagueTeamModal: (state: boolean) =>
    set(() => ({
      createLeagueTeamModal: state,
    })),
  addDiscountModal: false,
  setAddDiscountModal: (state: boolean) =>
    set(() => ({
      addDiscountModal: state,
    })),
  managePlayersModal: false,
  setManagePlayersModal: (state: boolean) =>
    set(() => ({
      managePlayersModal: state,
    })),

  //data
  stepCounter: 0,
  setStepCounter: (state: number) =>
    set(() => ({
      stepCounter: state,
    })),
  leagueTeams: [],
  setLeagueTeams: (state: LeagueTeamResp[]) =>
    set(() => ({
      leagueTeams: state,
    })),
  selectedTeam: null,
  setSelectedTeam: (state: LeagueTeamResp) =>
    set(() => ({
      selectedTeam: state,
    })),
  selectedDiscount: null,
  setSelectedDiscount: (state: LeagueDiscountResp) =>
    set(() => ({
      selectedDiscount: state,
    })),
})

export const manageTeamStore = create(manageTeamStoreStates)
